import './scoreTrendIndicator.css';

function ScoreTrendIndicator({currentAssessmentData, previousAssessmentData}) {

    console.log('prev people', previousAssessmentData.fields);
   let categories = ['Policy', 'People', 'Technology'];
   


   return (
    <ul className='score-trend-indicator-category-list'>
        {categories.map((category, index) => (
            <li key={index} className='score-trend-indicator-category-item'>
                <div className={currentAssessmentData[`${category}Score`] > previousAssessmentData.fields[`${category} Score`] ? 'trend-up' : currentAssessmentData[`${category}Score`] < previousAssessmentData.fields[`${category} Score`] ? 'trend-down' : currentAssessmentData[`${category}Score`] == previousAssessmentData.fields[`${category} Score`] ? 'no-trend' : 'unavailable'} title={`${category} : ${previousAssessmentData.fields[`${category} Score`]} -> ${currentAssessmentData[`${category}Score`]}`}></div>
            </li>
        ))}
    </ul>
   )
}

export default ScoreTrendIndicator;
